import React, { useEffect, useState } from 'react'
import {
  Option,
  OptionContainerSort,
  PlaceholderSpan,
  SelectContainerSort,
  SelectValueContainerSorting,
  DropdownIndicatorSort,
  OptionBold,
  OptionList,
  FilterText,
  Line,
} from './styles'
import expandIcon from 'src/static/icons/png/arrow_down.png'
import expandIconWhite from 'src/static/icons/png/dark-mode/arrow_down_white.png'
import { useTranslation } from 'react-i18next'
import { IS_BLACK_FRIDAY } from 'src/utils/globals'

export const CustomSelect = ({ defaultText, optionsList, setValue, name, className = '' }) => {
  const { t } = useTranslation('productFilters')

  const [selectedValue, setSelectedValue] = useState('DEFAULT')
  const [showOptionList, setShowOptionList] = useState(false)

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleClickOutside = e => {
    if (
      !e.target.classList.contains('custom-select-option') &&
      !e.target.classList.contains('selected-text')
    ) {
      setShowOptionList(false)
    }
  }

  const handleOptionClick = e => {
    setValue(e.target.getAttribute('data-value'))
    setSelectedValue(e.target.getAttribute('data-label'))
    setShowOptionList(false)
  }

  return (
    <SelectContainerSort
      className={`custom-select-container ${className}`}
      name={name}
      onClick={() => setShowOptionList(!showOptionList)}
    >
      <SelectValueContainerSorting
        tabIndex={0}
        className={'selected-text'}
        showOptionList={showOptionList}
      >
        <FilterText>{t('filter.sortBy')}&nbsp;</FilterText>
        {selectedValue !== '' && selectedValue.toLocaleUpperCase() !== 'DEFAULT' ? (
          selectedValue
        ) : (
          <PlaceholderSpan className={'selected-text'}>{defaultText}</PlaceholderSpan>
        )}
        <DropdownIndicatorSort src={IS_BLACK_FRIDAY ? expandIconWhite : expandIcon} />
      </SelectValueContainerSorting>
      {showOptionList && (
        <OptionContainerSort showOptionList={showOptionList}>
          {t('filter.sortBy')}&nbsp;
          {selectedValue !== '' && selectedValue.toLocaleUpperCase() !== 'DEFAULT' ? (
            selectedValue
          ) : (
            <PlaceholderSpan className={'selected-text'}>{defaultText}</PlaceholderSpan>
          )}
          <Line />
          <OptionList>
            {optionsList &&
              optionsList.length > 0 &&
              optionsList.map(option => {
                if (option.label.toLocaleLowerCase() === selectedValue.toLocaleLowerCase()) {
                  return (
                    <OptionBold
                      value={option.value}
                      tabIndex={0}
                      className="custom-select-option"
                      data-value={option.value}
                      data-label={option.label}
                      key={option.id}
                      onClick={handleOptionClick}
                    >
                      {option.label}
                    </OptionBold>
                  )
                }
                return (
                  <Option
                    value={option.value}
                    tabIndex={0}
                    className="custom-select-option"
                    data-value={option.value}
                    data-label={option.label}
                    key={option.id}
                    onClick={handleOptionClick}
                  >
                    {option.label}
                  </Option>
                )
              })}
          </OptionList>
        </OptionContainerSort>
      )}
    </SelectContainerSort>
  )
}

export default CustomSelect
